<template>
  <div class="searchPage">
    <div class="searchCon" v-loading="rearchLoading" element-loading-background="#fff">
      <div class="pageHeader">
        <el-button size="mini" type="primary" class="backBtn" @click="goback()"
          >返回</el-button
        >
        <p>{{ pageTitle }}</p>
      </div>
      <div v-if="searchPageType == 1" class="searchItem-box">
        <p class="tips">{{ tips }}</p>
        <div class="searchItem-con">
          <el-form ref="form" :model="searchForm" label-width="120px">
            <el-form-item label="目标天体：">
              <ul class="tilingSelect">
                <li
                  :class="{
                    'tilingSelect-item': true,
                    active: searchForm.target == 'all'
                  }"
                  val="all"
                  v-if="isShowType"
                  @click="selectTarget('all')"
                >
                  全部
                </li>
                <template v-for="(item, index) in targetData">
                  <li
                    :class="{
                      'tilingSelect-item': true,
                      active: searchForm.target == item.name
                    }"
                    :key="index"
                    :val="item.id"
                    v-if="item.isShow"
                    @click="selectTarget(item)"
                  >
                    {{ item.name.substring(0,item.name.indexOf("（")) }}
                  </li>
                </template>
              </ul>
              <ul class="tilingSelect" v-if="childTargetData.length > 0">
                <li
                  v-for="(item, index) in childTargetData"
                  :class="{
                    'tilingSelect-item': true,
                    active: searchForm.childTarget == item.name
                  }"
                  :key="index"
                  :val="item.id"
                  @click="selectChildTarget(item)"
                >
                  {{ item.name.substring(0,item.name.indexOf("（")) }}
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="坐标系：">
              <div class="form-item-inline">
                <el-select
                  v-model="searchForm.coordinateSystem.direction"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in config.searchItemData.coordinateSystem
                      .direction"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value + '_' + item.key"
                  ></el-option>
                </el-select>
              </div>
              <div class="form-item-inline">
                <el-select
                  v-model="searchForm.coordinateSystem.degree"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in config.searchItemData.coordinateSystem
                      .degree"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="form-item-inline">
                <el-select
                  v-model="searchForm.coordinateSystem.type"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in config.searchItemData.coordinateSystem.type"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value + '_' + item.key"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="纬度范围：">
              <div class="form-item-inline">
                <el-input v-model="searchForm.latitude.min"></el-input>
              </div>
              <div class="form-item-inline">-</div>
              <div class="form-item-inline">
                <el-input v-model="searchForm.latitude.max"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="经度范围：">
              <div class="form-item-inline">
                <el-input v-model="searchForm.longitude.min"></el-input>
              </div>
              <div class="form-item-inline">-</div>
              <div class="form-item-inline">
                <el-input v-model="searchForm.longitude.max"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="地形类别：">
              <ul class="tilingSelect">
                <li
                  :class="{
                    'tilingSelect-item': true,
                    active: searchForm.terrainClassification == 'all'
                  }"
                  val="all"
                  @click="searchForm.terrainClassification = 'all'"
                >
                  全部
                </li>
                <li
                  v-for="(item, index) in terrainClassification"
                  :class="{
                    'tilingSelect-item': true,
                    active: searchForm.terrainClassification == item.key+'_'+item.name
                  }"
                  :key="index"
                  :val="item.key+'_'+item.name"
                  @click="searchForm.terrainClassification = item.key+'_'+item.name"
                >
                  {{ item.name?item.name:item.key }}
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="地名：">
              <div class="form-item-inline">
                <el-input v-model="searchForm.placeName"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="直径（km）：">
              <div class="form-item-inline">
                <el-input v-model="searchForm.diameter.min"></el-input>
              </div>
              <span class="formItem-tips">(含)以上</span>
              <div class="form-item-inline">-</div>
              <div class="form-item-inline">
                <el-input v-model="searchForm.diameter.max"></el-input>
              </div>
              <span class="formItem-tips">(含)以下</span>
            </el-form-item>
            <el-form-item label="批准日期：">
              <el-date-picker
                v-model="searchForm.approvalStartDate"
                type="year"
                value-format="yyyy"
              ></el-date-picker>
              <div class="form-item-inline" style="margin-left: 15px">-</div>
              <el-date-picker
                v-model="searchForm.approvalEndDate"
                type="year"
                value-format="yyyy"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="批准状态：">
              <ul class="tilingSelect">
                <li
                  :class="{
                    'tilingSelect-item': true,
                    active: searchForm.approvalStatus == 'all'
                  }"
                  val="all"
                  @click="searchForm.approvalStatus = 'all'"
                >
                  全部
                </li>
                <li
                  v-for="(item, index) in config.searchItemData.approvalStatus"
                  :class="{
                    'tilingSelect-item': true,
                    active: searchForm.approvalStatus == item.value
                  }"
                  :key="index"
                  :val="item.value"
                  @click="searchForm.approvalStatus = item.value"
                >
                  {{ item.key }}
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="洲名：">
              <ul class="tilingSelect">
                <li
                  :class="{
                    'tilingSelect-item': true,
                    active: searchForm.islandName == 'all'
                  }"
                  val="all"
                  @click="searchForm.islandName = 'all'"
                >
                  全部
                </li>
                <li
                  v-for="(item, index) in config.searchItemData.islandName"
                  :class="{
                    'tilingSelect-item': true,
                    active: searchForm.islandName == item.value
                  }"
                  :key="index"
                  :val="item.value"
                  @click="searchForm.islandName = item.value"
                >
                  {{ item.key }}
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="种族：">
              <el-select v-model="searchForm.race" placeholder="请选择">
                <el-option
                  v-for="item in config.searchItemData.race"
                  :key="item.value"
                  :label="item.key"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="background:#0072ff;"
                size="small"
                @click="onSubmit"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="searchPageType == 2" class="searchItem-tabBox">
        <div class="searchItem-tabBox-con">
          <div class="searchCondition">
            <div class="searchCondition-title">检索条件：</div>
            <div class="searchCondition-con">
              <span
                class="searchCondition-item"
                v-for="(item, index) in searchCondition"
                :key="index"
              >
                {{ item.key }}：{{ item.value }}
                <span class="closeBtn" @click="delSearchItem(item.field, index)"
                  >x</span
                >
              </span>
              <span
                style="padding: 5px 20px;color: #333333;display: inline-block;"
                v-if="searchCondition.length == 0"
                >无</span
              >
            </div>
            <div class="searchCondition-searchName">
              <el-input
                class="searchNameIpt"
                placeholder="请输入地名"
                prefix-icon="el-icon-search"
                size="mini"
                v-model="searchName">
              </el-input>
              <el-button type="primary" size="mini" icon="el-icon-search" @click="searchNameFun"></el-button>
            </div>
          </div>
          <div class="searchBtnBox">
            <el-button type="primary" @click="isresultSearch"
              >结果中检索</el-button
            >
            <el-button style="float:right;" type="primary" @click="downLoadFun" :loading="downLoadLoading">下载</el-button
            >
            <el-dropdown
              trigger="click"
              :hide-on-click="false"
              style="float:right;"
            >
              <el-button type="primary">
                编辑列
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in tableConfig.tableHeaders"
                  :key="index"
                >
                  <el-checkbox
                    v-if="!item.type && item.type != 'index'"
                    v-model="item.isShow"
                    >{{ item.label }}</el-checkbox
                  >
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="tableBox">
            <div class="pageBox">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="requestData.page"
                :page-sizes="pageSizes"
                :page-size="requestData.limit"
                layout="total, sizes, prev, pager, next, jumper, slot"
                class="fr"
                :total="totalCount"
              >
                <el-button class="pageBtn">确认</el-button>
              </el-pagination>
            </div>
            <bitsTab
              ref="userAnswerTab"
              :config="tableConfig"
              :tableData="resourceListData"
              :page="requestData.page"
              :limit="requestData.limit"
              @handleSelection="handleSelection"
              @getData="getData"
              @sortChange="sortChange"
            >
              <div slot="featureName" slot-scope="scope">
                <span class="featureName" @click="gotoDetail(scope.rowData)">{{
                  scope.rowData.Feature_Name
                }}</span>
              </div>
            </bitsTab>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bitsTab from "@/components/table";
import cookie from '@/libs/util.cookie.js';
import { userType } from '@/libs/util.user.type';
export default {
  name: "searchPage",
  data() {
    var that = this;
    return {
      isShow: '',
      pageTitle: "高级搜索",
      tips:
        "该搜索引擎搜索行星表面特征名称的数据库。以下链接包含有关行星及其卫星名称的更多信息以及有关环和环间隙名称的信息。",
      searchPageType: 1,
      terrainClassification: require("@/assets/allCategory.json"),
      isShowType: true,
      searchForm: {
        target: "all",
        childTarget: "",
        coordinateSystem: {
          direction: "",
          degree: "",
          type: ""
        },
        latitude: {
          min: "",
          max: ""
        },
        longitude: {
          min: "",
          max: ""
        },
        terrainClassification: "all",
        placeName: "",
        diameter: {
          min: "",
          max: ""
        },
        approvalStartDate: "",
        approvalEndDate: "",
        approvalStatus: "all",
        islandName: "all",
        race: ""
      },
      searchCondition: [],
      searchName: "",
      tableConfig: {
        tabKey: "userAnswerTab",
        isShow: true,
        tableHeaders: [
          {
            type: "index",
            isShow: true,
            index: 1
          },
          {
            prop: "_id",
            isShow: true,
            label: "ID",
            width: 70
          },
          {
            prop: "Feature_Name",
            isShow: true,
            label: "外文地名",
            sortable: "custom",
            template: "featureName",
            width: 120
          },
          {
            prop: "Clean_Feature_Name",
            isShow: false,
            label: "简化外文地名"
          },
          {
            prop: "CN_Name",
            isShow: true,
            sortable: "custom",
            label: "中文地名",
            width: 120
          },
          {
            prop: "Target",
            isShow: false,
            label: "目标天体"
          },
          {
            prop: "Diameter",
            isShow: true,
            sortable: "custom",
            label: "直径（km）",
            width: 120
          },
          {
            prop: "Center_Latitude",
            isShow: true,
            label: "中心纬度"
          },
          {
            prop: "Center_Longitude",
            isShow: true,
            label: "中心经度",
            formatter:function(value) {
              var coordinateSystem = false,degree = false;
              for (let i = 0; i < that.searchCondition.length; i++) {
                if (that.searchCondition[i].field == 844 && that.searchCondition[i].value == "西") {
                  coordinateSystem = true;
                }
                if (that.searchCondition[i].field == 845 && that.searchCondition[i].value == "0 - 360") {
                  degree = true;
                }
              }
              if (coordinateSystem && degree) {
                return (parseFloat(value) + 360).toFixed(2);
              } else {
                return value;
              }
            }
          },
          {
            prop: "Northern_Latitude",
            isShow: false,
            label: "北边界维度"
          },
          {
            prop: "Southern_Latitude",
            isShow: false,
            label: "南边界维度"
          },
          {
            prop: "Eastern_Longitude",
            isShow: false,
            label: "东边界经度"
          },
          {
            prop: "Western_Longitude",
            isShow: false,
            label: "西边界经度"
          },
          {
            prop: "Coordinate_System",
            isShow: false,
            label: "坐标系统"
          },
          {
            prop: "Continent",
            isShow: false,
            label: "洲名"
          },
          {
            prop: "Ethnicity",
            isShow: true,
            label: "种族",
            width: 120
          },
          {
            prop: "Feature_Type",
            isShow: true,
            label: "地形类别",
            width: 125
          },
          {
            prop: "Feature_Type_Code",
            isShow: false,
            label: "地形类别代码"
          },
          {
            prop: "Quad",
            isShow: true,
            label: "Quad"
          },
          {
            prop: "DOM",
            isShow: this.$route.query.target == "月球（The Moon）",
            label: "DOM",
            width: 95
          },
          {
            prop: "DEM",
            isShow: this.$route.query.target == "月球（The Moon）",
            label: "DEM",
            width: 95
          },
          {
            prop: "Approval_Status",
            isShow: false,
            label: "批准状态"
          },
          {
            prop: "approval_date",
            isShow: false,
            label: "批准时间"
          },
          {
            prop: "Reference",
            isShow: false,
            label: "参考文献"
          },
          {
            prop: "Origin",
            isShow: true,
            label: "命名来源",
            align: "left",
            width: 300,
            formatter:function(value) {
              if (value && value.indexOf("?") == -1 && !(/.*[\u4e00-\u9fa5]+.*$/.test(value))) {
                return value;
              } else {
                return "-";
              }
            }
          },
          {
            prop: "Additional_Info",
            isShow: false,
            label: "附加信息",
            formatter:function(value) {
              if (value && value.indexOf("?") == -1 && !(/.*[\u4e00-\u9fa5]+.*$/.test(value))) {
                return value;
              } else {
                return "-";
              }
            }
          },
          {
            prop: "Last_Updated",
            isShow: false,
            label: "最后更新日期"
          }
        ]
      },
      pageSizes: [10, 20, 50, 100],
      totalCount: 1,
      requestData: {
        page: 1,
        limit: 10,
        types: "155"
      },
      selectList: [],
      resourceListData: [],
      targetData: [],
      childTargetData: [],
      downLoadLoading: false,
      rearchLoading: false
    };
  },
  created() {
    this.isShow = cookie.get('user') ? JSON.parse(cookie.get('user')).token : '';
    if(userType() === 'user' || userType() === 'visitor') {
      this.isShowType = false;
    }
    var that = this;
    that.getTargetData();
    if (that.$route.query.type == 2) {
      that.searchPageType = 2;
    }
    if (that.$route.query.terrainClassification) {
      that.searchForm.terrainClassification =
        that.$route.query.terrainClassification;
        that.onSubmit();
    }
    if (that.$route.query.ethnicity) {
      that.searchForm.race =
        that.$route.query.ethnicity;
        that.onSubmit();
    }
    if (that.$route.query.searchKey) {
      that.searchForm.placeName = that.$route.query.searchKey;
      that.onSubmit();
    }
    if (!that.$route.query.indexSearch) {
      that.searchForm.coordinateSystem = {
        direction: "+East_东",
        degree: "0 - 360",
        type: "Planetocentric_行星心"
      };
      that.searchForm.approvalStartDate = "1935";
      that.searchForm.approvalEndDate = new Date().getFullYear()+"";
    }
    if (that.$route.query.title) {
      that.pageTitle = that.$route.query.title;
    }
    if(that.$route.query && that.$route.query.is) {
      that.rearchLoading = true;
      let isData = setInterval(function() {
        if(that.targetData.length > 0) {
          that.selectTarget(that.targetData[0]);
          setTimeout(function() {
            that.rearchLoading = false;
          }, 200);
          window.clearInterval(isData);
        }
      }, 200);
    }
  },
  methods: {
    isresultSearch() {
      this.searchPageType = 1;
      if(userType() === 'user' || userType() === 'visitor') {
        // this.selectTarget(this.targetData[0]);
      }
    },
    getTargetData() {
      var that = this;
      that
        .axios({
          method: "get",
          url: "/front/resourceCategory/front/queryList",
          params: {
            pid: that.config.channelId.placeName.id,
            typeLevel: "all"
          }
        })
        .then(function(res) {
          that.targetData = res.data.result;
          if(userType() === 'user' || userType() === 'visitor') {
            for (let i = 0; i < that.targetData.length; i++) {
              if(i > 1) {
                that.targetData[i].isShow = false;
              } else {
                that.targetData[i].isShow = true;
              }
            }
          } else {
            for (let i = 0; i < that.targetData.length; i++) {
              that.targetData[i].isShow = true;
            }
          }
          if (that.$route.query.target) {
            if (that.$route.query.childTarget) {
              for (let i = 0; i < that.targetData.length; i++) {
                if (that.$route.query.target == that.targetData[i].name) {
                  that.childTargetData = that.targetData[i].child;
                }
              }
              that.searchForm.target = that.$route.query.target;
              that.searchForm.childTarget = that.$route.query.childTarget;
              that.onSubmit();
              var pvalue = that.$route.query.target.substring(that.$route.query.target.indexOf("（")+1, that.$route.query.target.indexOf("）"));
              var cvalue = that.$route.query.childTarget.substring(that.$route.query.childTarget.indexOf("（")+1, that.$route.query.childTarget.indexOf("）"));
              that.getTypeDat(pvalue,cvalue);
            } else {
              that.searchForm.target = that.$route.query.target;
              that.onSubmit();
              var value = that.$route.query.target.substring(that.$route.query.target.indexOf("（")+1, that.$route.query.target.indexOf("）"));
              that.getTypeDat("",value);
            }
          }
        })
        .catch(function() {});
    },
    selectTarget(item){
      var that = this;
      that.searchForm.terrainClassification = "all";
      if(item == "all"){
        that.searchForm.target = "all";
        that.terrainClassification = require("@/assets/allCategory.json");
      }else{
        that.searchForm.target = item.name;
        if(item.child.length > 0){
          for (let i = 0; i < item.child.length; i++) {
            if (item.child[i].name.indexOf("星环") > -1) {
              item.child.splice(i,1);
            }
          }
          that.childTargetData = item.child;
          that.searchForm.childTarget = item.child[0].name;
          var pValue = item.name.substring(item.name.indexOf("（")+1, item.name.indexOf("）"));
          var value = item.child[0].name.substring(item.child[0].name.indexOf("（")+1, item.child[0].name.indexOf("）"));
          that.getTypeDat(pValue,value);
        }else{
          that.childTargetData = [];
          that.searchForm.childTarget = "";
          var value2 = item.name.substring(item.name.indexOf("（")+1, item.name.indexOf("）"));
          that.getTypeDat("",value2);
        }
      }
    },
    selectChildTarget(item) {
      var that = this;
      that.searchForm.childTarget = item.name;
      var pValue = that.searchForm.target.substring(that.searchForm.target.indexOf("（")+1, that.searchForm.target.indexOf("）"));
      var value = item.name.substring(item.name.indexOf("（")+1, item.name.indexOf("）"));
      that.getTypeDat(pValue,value);
    },
    getTypeDat(pValue,value) {
      var that = this;
      var url = "/front/features";
      if(value == "The Moon"){
        value = "Moon";
      }
      if(pValue){
        url += "/"+pValue.replace(" ","");
        if(value){
          url += "/"+value.replace(" ","");
        }
      }else{
        if(value){
          url += "/"+value.replace(" ","");
          url += "/"+value.replace(" ","");
        }
      }
      if(url){
        that
          .axios({
            method: "get",
            url: url
          })
          .then(function(res) {
            that.terrainClassification = res.data.result;
          })
          .catch(function() {});
      }
    },
    searchNameFun() {
      var that = this;
      // that.$route.query.key = that.searchName;
      that.requestData.keywords = [that.searchName];
      that.getData();
      // that.$route.query.searchName = that.searchName;
      // that.$router.push({
      //   path: "/search",
      //   query: that.$route.query
      // });
    },
    onSubmit() {
      var that = this;
      that.pageTitle = "高级搜索";
      if (that.searchName) {
        that.requestData.keywords = [that.searchName];
      } else {
        that.requestData.keywords = [];
      }
      that.requestData.queryConditions = [];
      that.requestData.rangeConditions = [];
      that.searchCondition = [];
      if (that.searchForm.target && that.searchForm.target != "all") {
        var value = "";
        var showValue = "";
        if(that.searchForm.childTarget){
          value = that.searchForm.childTarget.substring(that.searchForm.childTarget.indexOf("（")+1, that.searchForm.childTarget.indexOf("）")).replace(" ","");
          showValue = that.searchForm.childTarget.substring(0, that.searchForm.childTarget.indexOf("（")).replace(" ","");
        }else{
          value = that.searchForm.target.substring(that.searchForm.target.indexOf("（")+1, that.searchForm.target.indexOf("）")).replace(" ","");
          showValue = that.searchForm.target.substring(0, that.searchForm.target.indexOf("（")).replace(" ","");
        }
        if(value == "TheMoon"){
          value = "Moon";
        }
        that.requestData.queryConditions.push({
            fields: ["835"],
            queryIncludeEnum: "MUST",
            queryOperator: "AND",
            queryTypeEnum: "TERM",
            queryValue: value,
            queryWordFrequency: "NINE"
          });
          that.searchCondition.push({
            key: "目标天体",
            value: showValue,
            field: "835"
          });
      }
      if (that.searchForm.coordinateSystem.direction) {
        // that.requestData.queryConditions.push({
        //   fields: ["844"],
        //   queryIncludeEnum: "MUST",
        //   queryOperator: "AND",
        //   queryTypeEnum: "TERM",
        //   queryValue: that.searchForm.coordinateSystem.direction.split("_")[0],
        //   queryWordFrequency: "NINE"
        // });
        that.searchCondition.push({
          key: "坐标系东西区",
          value: that.searchForm.coordinateSystem.direction.split("_")[1],
          field: "844"
        });
      }
      if (that.searchForm.coordinateSystem.degree) {
        // that.requestData.queryConditions.push({
        //   fields: ["845"],
        //   queryIncludeEnum: "MUST",
        //   queryOperator: "AND",
        //   queryTypeEnum: "TERM",
        //   queryValue: that.searchForm.coordinateSystem.degree,
        //   queryWordFrequency: "NINE"
        // });
        that.searchCondition.push({
          key: "坐标系度数",
          value: that.searchForm.coordinateSystem.degree,
          field: "845"
        });
      }
      if (that.searchForm.coordinateSystem.type) {
        // that.requestData.queryConditions.push({
        //   fields: ["843"],
        //   queryIncludeEnum: "MUST",
        //   queryOperator: "AND",
        //   queryTypeEnum: "TERM",
        //   queryValue: that.searchForm.coordinateSystem.type.split("_")[0],
        //   queryWordFrequency: "NINE"
        // });
        that.searchCondition.push({
          key: "坐标系相对于行星位置",
          value: that.searchForm.coordinateSystem.type.split("_")[1],
          field: "843"
        });
      }
      if (that.searchForm.latitude.min || that.searchForm.latitude.max) {
        that.requestData.rangeConditions.push({
          field: "837",
          maxValue: that.searchForm.latitude.max,
          minValue: that.searchForm.latitude.min,
          queryOperator: "AND"
        });
        that.searchCondition.push({
          key: "纬度范围",
          value:
            that.searchForm.latitude.min + " - " + that.searchForm.latitude.max,
          field: "837"
        });
      }
      if (that.searchForm.longitude.min || that.searchForm.longitude.max) {
        that.requestData.rangeConditions.push({
          field: "838",
          maxValue: that.searchForm.longitude.max,
          minValue: that.searchForm.longitude.min,
          queryOperator: "AND"
        });
        that.searchCondition.push({
          key: "经度范围",
          value:
            that.searchForm.longitude.min +
            " - " +
            that.searchForm.longitude.max,
          field: "838"
        });
      }
      if (
        that.searchForm.terrainClassification &&
        that.searchForm.terrainClassification != "all"
      ) {
        that.requestData.queryConditions.push({
          fields: ["848"],
          queryIncludeEnum: "MUST",
          queryOperator: "AND",
          queryTypeEnum: "TERM",
          queryValue: that.searchForm.terrainClassification.split("_")[0],
          queryWordFrequency: "NINE"
        });
        that.searchCondition.push({
          key: "地形类别",
          value: that.searchForm.terrainClassification.split("_")[1],
          field: "848"
        });
      }
      if (that.searchForm.placeName) {
        that.requestData.keywords.push(that.searchForm.placeName);
        that.searchCondition.push({
          key: "地名",
          value: that.searchForm.placeName,
          field: "keywords"
        });
      }
      if (that.searchForm.diameter.min || that.searchForm.diameter.max) {
        that.requestData.rangeConditions.push({
          field: "836",
          maxValue: that.searchForm.diameter.max,
          minValue: that.searchForm.diameter.min,
          queryOperator: "AND"
        });
        that.searchCondition.push({
          key: "直径",
          value:
            that.searchForm.diameter.min + " - " + that.searchForm.diameter.max,
          field: "836"
        });
      }
      if (
        that.searchForm.approvalStartDate &&
        that.searchForm.approvalEndDate
      ) {
        // var startData = that.dateToString(that.searchForm.approvalDate[0]);
        // var endData = that.dateToString(that.searchForm.approvalDate[1]);
        that.requestData.rangeConditions.push({
          field: "906",
          maxValue: that.searchForm.approvalEndDate,
          minValue: that.searchForm.approvalStartDate,
          queryOperator: "AND"
        });
        that.searchCondition.push({
          key: "批准日期",
          value: that.searchForm.approvalStartDate + " - " + that.searchForm.approvalEndDate,
          field: "906"
        });
      }
      if (
        that.searchForm.approvalStatus &&
        that.searchForm.approvalStatus != "all"
      ) {
        that.requestData.queryConditions.push({
          fields: ["854"],
          queryIncludeEnum: "MUST",
          queryOperator: "AND",
          queryTypeEnum: "TERM",
          queryValue: that.searchForm.approvalStatus,
          queryWordFrequency: "NINE"
        });
        that.searchCondition.push({
          key: "批准状态",
          value: that.searchForm.approvalStatus,
          field: "854"
        });
      }
      if (that.searchForm.islandName && that.searchForm.islandName != "all") {
        that.requestData.queryConditions.push({
          fields: ["846"],
          queryIncludeEnum: "MUST",
          queryOperator: "AND",
          queryTypeEnum: "TERM",
          queryValue: that.searchForm.islandName,
          queryWordFrequency: "NINE"
        });
        that.searchCondition.push({
          key: "洲名",
          value: that.searchForm.islandName,
          field: "846"
        });
      }
      if (that.searchForm.race) {
        that.requestData.queryConditions.push({
          fields: ["847"],
          queryIncludeEnum: "MUST",
          queryOperator: "AND",
          queryTypeEnum: "TERM",
          queryValue: that.searchForm.race,
          queryWordFrequency: "NINE"
        });
        that.searchCondition.push({
          key: "种族",
          value: that.searchForm.race,
          field: "847"
        });
      }
      that.searchPageType = 2;
      that.getData();
    },
    gotoDetail(rowData) {
      var that = this;
      that.$router.push({
        path: "/searchDetail",
        query: { id: rowData.guid, title: encodeURI("详情") }
      });
    },
    dateToString(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString();
      var day = date.getDate().toString();
      if (month.length == 1) {
        month = "0" + month;
      }
      if (day.length == 1) {
        day = "0" + day;
      }
      var dateTime = year + "-" + month + "-" + day;
      return dateTime;
    },
    // 列表显示数量变化
    handleSizeChange(val) {
      this.tableConfig.loading = true;
      this.requestData.limit = val;
      this.getData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.tableConfig.loading = true;
      this.requestData.page = val;
      this.getData();
    },
    // 表格选择
    handleSelection(selectList) {
      this.selectList = selectList;
    },
    sortChange(obj) {
      if (obj.order == "descending") {
        this.requestData.sort = obj.prop + "|desc";
      }
      if (obj.order == "ascending") {
        this.requestData.sort = obj.prop + "|asc";
      }
      if (!obj.order) {
        this.requestData.sort = "";
      }
      this.getData();
    },
    getData() {
      var that = this;
      that.resourceListData = [];
      that
        .axios({
          method: "post",
          url: "/front/search/advance",
          headers: {
            "Content-type": "application/json"
          },
          data: JSON.stringify(that.requestData)
        })
        .then(function(res) {
          that.tableConfig.loading = false;
          that.resourceListData = res.data.result;
          if (res.data.paginator) {
            that.totalCount = res.data.paginator.totalCount;
          } else {
            that.totalCount = 0;
          }
        })
        .catch(function() {});
    },
    goback() {
      this.$router.back();
    },
    delSearchItem(field, index) {
      var that = this;
      if (field == "keywords") {
        that.requestData.keywords = [];
      } else {
        for (let i = 0; i < that.requestData.queryConditions.length; i++) {
          if (that.requestData.queryConditions[i].fields[0] == field) {
            that.requestData.queryConditions.splice(i, 1);
          }
        }
        for (let j = 0; j < that.requestData.rangeConditions.length; j++) {
          if (that.requestData.rangeConditions[j].field == field) {
            that.requestData.rangeConditions.splice(j, 1);
          }
        }
      }
      that.searchCondition.splice(index, 1);
      that.getData();
    },
    downLoad() {
      this.dialogFormVisible = true;
    },
    downLoadFun() {
      var that = this;
      if(that.isShow) {
        that.downLoadLoading = true;
        that
          .axios({
            method: "post",
            url: "/front/user/checkLogin",
            data: {}
          })
          .then(function(res) {
            if(res.data.code === 200) {
              var excelRequestData = JSON.parse(JSON.stringify(that.requestData));
              excelRequestData.count = that.totalCount;
              excelRequestData.baseMap = [];
              for (let i = 0; i < that.tableConfig.tableHeaders.length; i++) {
                if (
                  that.tableConfig.tableHeaders[i].isShow &&
                  that.tableConfig.tableHeaders[i].prop
                ) {
                  excelRequestData.baseMap.push({
                    key: that.tableConfig.tableHeaders[i].prop,
                    value: that.tableConfig.tableHeaders[i].label
                  });
                }
              }
              that
                .axios({
                  method: "post",
                  url: "/front/search/excelAdvance",
                  headers: {
                    "Content-type": "application/json"
                  },
                  data: JSON.stringify(excelRequestData)
                })
                .then(function(data) {
                  if (data.data.code == 200) {
                    window.open(that.config.fileCtx + data.data.result);
                    that.downLoadLoading = false;
                  }
                })
                .catch(function() {
                  that.downLoadLoading = false;
                });
            } else {
              that.$router.push({path: 'login'});
            }
          })
          .catch(function() {});
      } else {
        that.$router.push({path: '/login'});
      }
    }
  },
  components: {
    bitsTab
  },
  watch:{
    '$route'(){
      var that = this;
      that.getTargetData();
      if (that.$route.query.type == 2) {
        that.searchPageType = 2;
      }
      if (that.$route.query.terrainClassification) {
        that.searchForm.terrainClassification =
          that.$route.query.terrainClassification;
          that.onSubmit();
      }
      if (that.$route.query.ethnicity) {
        that.searchForm.race =
          that.$route.query.ethnicity;
          that.onSubmit();
      }
      if (that.$route.query.searchKey) {
        that.searchForm.placeName = that.$route.query.searchKey;
        that.onSubmit();
      }
      if (that.$route.query.target) {
        that.searchForm.target = that.$route.query.target;
        that.onSubmit();
      }
      if (!that.$route.query.indexSearch) {
        that.searchForm.coordinateSystem = {
          direction: "+East_东",
          degree: "0 - 360",
          type: "Planetocentric_行星心"
        };
        that.searchForm.approvalStartDate = "1935";
        that.searchForm.approvalEndDate = new Date().getFullYear()+"";
      }
      if (that.$route.query.title) {
        that.pageTitle = that.$route.query.title;
      }
    }
  }
};
</script>

<style scoped>
.searchPage {
  width: 1320px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  padding: 30px 0;
  box-sizing: border-box;
}

.backBtn {
  float: right;
  margin-top: -8px;
}

.searchCon {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 8px;
  overflow: auto;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.pageHeader{
  border-bottom: 1px solid #dedede;
  padding-bottom: 15px;
}

.pageHeader p{
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}

/* searchItem-box */
.tips {
  font-size: 14px;
  color: #333333;
  margin: 20px 0 15px;
}

.searchItem-con {
  border: 1px solid #e8e8e8;
  padding: 10px;
}

.form-item-inline {
  display: inline-block;
  margin-right: 15px;
}

.formItem-tips {
  display: inline-block;
  width: 60px;
}

.tilingSelect {
  display: flex;
  flex-wrap: wrap;
}

.tilingSelect-item {
  padding: 6px 12px;
  font-size: 14px;
  line-height: 14px;
  margin: 7px 10px;
  color: #474747;
  cursor: pointer;
}

.tilingSelect-item.active {
  background: #0072ff;
  color: #ffffff;
  border-radius: 15px;
}
/* searchItem-box */

/* searchItem-tabBox */
.searchItem-tabBox {
  width: 100%;
  overflow: auto;
}

.searchItem-tabBox-con{
  width: max-content;
  padding: 10px 10px 10px 0;
}

.searchCondition {
  margin-bottom: 10px;
  display: flex;
}

.searchCondition-con{
  flex: 1;
  margin-right: 10px;
}

.searchCondition-title {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  line-height: 24px;
}

.searchCondition-item {
  padding: 5px 20px;
  background: #f4f4f4;
  margin-right: 10px;
  color: #333333;
  position: relative;
  display: inline-block;
  margin-bottom: 5px;
}

.searchCondition-item .closeBtn {
  display: inline-block;
  width: 12px;
  height: 12px;
  text-align: center;
  line-height: 12px;
  font-size: 12px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.searchCondition-searchName{
  display: flex;
  height: 28px;
}

/* .tableBox { */
/* padding: 20px 0; */
/* } */

.pageBox {
  overflow: hidden;
  padding: 10px 0;
}
/* searchItem-tabBox */
.featureName {
  cursor: pointer;
  color: #005aff;
  text-decoration: underline;
}
</style>
<style>
.searchPage .el-form-item {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f1f1f1;
}

.searchPage .el-form-item:last-child {
  border: none;
}

.el-dropdown-menu {
  max-height: 500px;
  overflow: auto;
}

.searchPage .el-table__body-wrapper,.searchPage .el-table__footer-wrapper,.searchPage .el-table__header-wrapper{
  width: max-content;
}

.searchPage .el-table{
  max-width: initial!important;
  width: max-content!important;
}
</style>
